import ServiceCRUD from '../../../../services/ServiceCRUD';
import { apiCase as http } from '../../../../http';

class CustomerPortfolioService extends ServiceCRUD {
  constructor() {
    super('customer-portfolio');
  }

  getWithoutPagination(showDisabled = false, showOnlyWithoutMatrix = false) {
    return http.get(
      `${this.path}/all?showDisabled=${showDisabled}&showOnlyWithoutMatrix=${showOnlyWithoutMatrix}`
    );
  }

  getAllAccountsByPortfolioId(portfolioId, queryParams) {
    return http.get(`${this.path}/${portfolioId}/accounts`, {
      params: queryParams
    });
  }

  getCustomerPortfolio(queryParams) {
    return http.get(`${this.path}`, {
      params: queryParams
    });
  }

  createCustomerPortfolio(data, usrLogin) {
    return http.post(this.path, data, {
      headers: {
        'usr-login': usrLogin
      }
    });
  }

  updateCustomerPortfolio(id, data, usrLogin) {
    return http.put(`${this.path}/${id}`, data, {
      headers: {
        'usr-login': usrLogin
      }
    });
  }

  enable(id, usrLogin) {
    return http.put(`${this.path}/enable/${id}`, null, {
      headers: {
        'usr-login': usrLogin
      }
    });
  }

  disable(id, usrLogin) {
    return http.put(`${this.path}/disable/${id}`, null, {
      headers: {
        'usr-login': usrLogin
      }
    });
  }

  deleteCustomerPortfolio(id, usrLogin) {
    return http.delete(`${this.path}/${id}`, {
      headers: {
        'usr-login': usrLogin
      }
    });
  }

  updateMultipleAccountsWithANewPortfolio(id, data, usrLogin) {
    return http.put(`${this.path}/${id}/accounts`, data, {
      headers: {
        'usr-login': usrLogin
      }
    });
  }

  getCustomerPortfolioByAccountId(accountId) {
    return http.get(`${this.path}/account/${accountId}`);
  }
}

export default new CustomerPortfolioService();
